import React from 'react';

const CustomerMasterPage = () => {
    return (
        <div>
            
        </div>
    );
}

export default CustomerMasterPage;
